import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import TrekkingTours from './pages/TrekkingTours';
import ValleyOfFlowers from './pages/tours/ValleyOfFlowers';
import SarPass from './pages/tours/SarPass';
import Kedarkantha from './pages/tours/Kedarkantha';
import KuariPass from './pages/tours/KuariPass';
import KashmirGreatLakes from './pages/tours/KashmirGreatLakes';
import KareriLake from './pages/tours/KareriLake';
import ParasharLake from './pages/tours/ParasharLake';
import HarKiDun from './pages/tours/HarKiDun';
import HamptaPass from './pages/tours/HamptaPass';
import DayaraBugyal from './pages/tours/DayaraBugyal';
import BhriguLake from './pages/tours/BhriguLake';
import Brahmatal from './pages/tours/Brahmatal';
import NagTibba from './pages/tours/NagTibba';
import GaumukhTapovan from './pages/tours/GaumukhTapovan';
import BeasKund from './pages/tours/BeasKund';
import BunbuniPass from './pages/tours/BunbuniPass';
import PhularaRidge from './pages/tours/PhularaRidge';
import ManaliKasol from './pages/tours/ManaliKasol';
import BaliPass from './pages/tours/BaliPass';
import BuranGhati from './pages/tours/BuranGhati';
import Kanatal from './pages/tours/Kanatal';
import Chakrata from './pages/tours/Chakrata';
import Mukteshwar from './pages/tours/Mukteshwar';
import YullaKanda from './pages/tours/YullaKanda';
import Jibhi from './pages/tours/Jibhi';
import Jaisalmer from './pages/tours/Jaisalmer';
import Udaipur from './pages/tours/Udaipur';
import Harsil from './pages/tours/Harsil';
import Mcleodganj from './pages/tours/Mcleodganj';
import Churdhar from './pages/tours/Churdhar';
import SpitiValley from './pages/destinations/SpitiValley';
import Meghalaya from './pages/destinations/Meghalaya';
import Kashmir from './pages/destinations/Kashmir';
import Kerala from './pages/destinations/Kerala';
import Ladakh from './pages/Ladakh';
import PanchKailash from './pages/PanchKailash';
import PanchKedar from './pages/PanchKedar';
import RudranathTour from './pages/tours/RudranathTour';
import MadhmaheshwarTour from './pages/tours/MadhmaheshwarTour';
import TungnathTour from './pages/tours/TungnathTour';
import KedarnathTour from './pages/tours/KedarnathTour';
import AdiKailashTour from './pages/tours/AdiKailashTour';
import KinnerKailashTour from './pages/tours/KinnerKailashTour';
import ShrikhandMahadevTour from './pages/tours/ShrikhandMahadevTour';
import ManimaheshTour from './pages/tours/ManimaheshTour';
import WriteToUs from './pages/WriteToUs';
import TermsConditions from './pages/TermsConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CancellationPolicy from './pages/CancellationPolicy';
import NotFound from './pages/NotFound';
import ScrollToTop from './components/common/ScrollToTop';
import './App.css';

function App() {
  return (
    <div className="App">
      <Helmet>
        <title>NomadTrailz - Premium Travel & Trekking Tours Across India</title>
        <meta name="description" content="Discover 46+ premium travel packages across India with NomadTrailz. Book weekend trips, trekking adventures, Panch Kailash, Panch Kedar, Leh Ladakh tours." />
      </Helmet>
      
      <ScrollToTop />
      
      <Header />
      
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/trekking-tours" element={<TrekkingTours />} />
          <Route path="/valley-of-flowers" element={<ValleyOfFlowers />} />
          <Route path="/sar-pass-trek" element={<SarPass />} />
          <Route path="/kedarkantha-trek" element={<Kedarkantha />} />
          <Route path="/kuari-pass-trek" element={<KuariPass />} />
          <Route path="/kashmir-great-lake-trek" element={<KashmirGreatLakes />} />
          <Route path="/kareri-lake-trek" element={<KareriLake />} />
          <Route path="/parashar-lake-trek" element={<ParasharLake />} />
          <Route path="/har-ki-dun-trek" element={<HarKiDun />} />
          <Route path="/hampta-pass-trek" element={<HamptaPass />} />
          <Route path="/dayara-bugyal-trek" element={<DayaraBugyal />} />
          <Route path="/bhrigu-lake-trek" element={<BhriguLake />} />
          <Route path="/brahmatal-trek" element={<Brahmatal />} />
          <Route path="/nag-tibba-trek" element={<NagTibba />} />
          <Route path="/gaumukh-tapovan-trek" element={<GaumukhTapovan />} />
          <Route path="/beas-kund-trek" element={<BeasKund />} />
          <Route path="/bunbuni-pass-trek" element={<BunbuniPass />} />
          <Route path="/phulara-ridge-trek" element={<PhularaRidge />} />
          <Route path="/manali-kasol-tour" element={<ManaliKasol />} />
          <Route path="/bali-pass-trek" element={<BaliPass />} />
          <Route path="/buran-ghati-trek" element={<BuranGhati />} />
          <Route path="/kanatal-tehri-lake" element={<Kanatal />} />
          <Route path="/chakrata-tiger-waterfall" element={<Chakrata />} />
          <Route path="/mukteshwar" element={<Mukteshwar />} />
          <Route path="/yulla-kanda" element={<YullaKanda />} />
          <Route path="/jibhi-tirthan" element={<Jibhi />} />
          <Route path="/jaisalmer" element={<Jaisalmer />} />
          <Route path="/udaipur" element={<Udaipur />} />
          <Route path="/harsil-valley" element={<Harsil />} />
          <Route path="/mcleodganj-triund" element={<Mcleodganj />} />
          <Route path="/churdhar" element={<Churdhar />} />
          <Route path="/spiti-valley" element={<SpitiValley />} />
          <Route path="/meghalaya" element={<Meghalaya />} />
          <Route path="/kashmir" element={<Kashmir />} />
          <Route path="/kerala" element={<Kerala />} />
          <Route path="/leh-ladakh" element={<Ladakh />} />
          <Route path="/panch-kailash" element={<PanchKailash />} />
          <Route path="/panch-kedar" element={<PanchKedar />} />
          <Route path="/rudranath-tour" element={<RudranathTour />} />
          <Route path="/madhmaheshwar-tour" element={<MadhmaheshwarTour />} />
          <Route path="/tungnath-tour" element={<TungnathTour />} />
          <Route path="/chopta-tungnath-trek" element={<TungnathTour />} />
          <Route path="/chopta-tungnath" element={<TungnathTour />} />
          <Route path="/kedarnath-tour" element={<KedarnathTour />} />
          <Route path="/adi-kailash-tour" element={<AdiKailashTour />} />
          <Route path="/kinner-kailash-tour" element={<KinnerKailashTour />} />
          <Route path="/shrikhand-mahadev-tour" element={<ShrikhandMahadevTour />} />
          <Route path="/manimahesh-tour" element={<ManimaheshTour />} />
          <Route path="/write-to-us" element={<WriteToUs />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cancellation-policy" element={<CancellationPolicy />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      
      <Footer />
    </div>
  );
}

export default App;
